import axios from 'axios';
import type {
  DownloadUrlResponse,
  LegendStorageFilesResponse,
  StorageFileReplaceRequest,
  StorageFileUploadRequest,
  StorageFileUploadResponse,
} from '@shared/types/legend-storage.service.types';
import { setupUserBlockInterceptor } from '@shared/utils/setupUserBlockInterceptor';

const storageApi = axios.create({
  baseURL: import.meta.env.VITE_API_STORAGE_URL as string,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

setupUserBlockInterceptor(storageApi);

export const legendStorageService = {
  async uploadRewardFile(data: StorageFileUploadRequest) {
    return await storageApi.post<StorageFileUploadResponse>('/files', data);
  },
  async replaceRewardFile(data: StorageFileReplaceRequest) {
    return await storageApi.post<StorageFileUploadResponse>(
      '/files/replace',
      data,
    );
  },
  async getFiles() {
    return await storageApi.get<LegendStorageFilesResponse>('/files');
  },
  async getDownloadUrl(key: string) {
    const normalized = key.replace(/^\/+/, '');
    const encodedKey = normalized.split('/').map(encodeURIComponent).join('/');
    return await storageApi.get<DownloadUrlResponse>(
      `/files/download/${encodedKey}`,
    );
  },
};
